
export const FORM_ERROR_STATUS = 'FORM_ERROR'
export const FORM_PROGRESS_STATUS = 'FORM_INPROGRESS'
export const FORM_SUBMIT_STATUS = 'FORM_SUBMIT'
export const FORM_ACTION_ERROR_STATUS = 'FORM_ACTION_ERROR'

export const TAG_DATA = 'TAG_DATA'
export const TRAP_DATA = 'TRAP_DATA'
export const GROUP_DATA = 'GROUP_DATA'



// WEBPACK FOOTER //
// ./src/constants/form.js